// Pure, side-effect-free canonical word->landing-topic mapping. Extracted into its own .mjs —
// same dual-loadable convention as translationPrompt.mjs — specifically so
// scripts/build-search-index.js (a plain Node CommonJS script) can dynamic-`import()` the exact
// same algorithm GlobalSearch.js uses in the browser, instead of maintaining a second copy that
// could silently diverge on which topic a word_id resolves to.
// No imports of firebase/auth/React here on purpose: this file must be loadable by both a
// browser bundle and bare Node with zero extra setup.

// A word_id can occur in multiple topics (role_in_topic: "recycled"), but a flashcard only
// exists at its "new" occurrence (see app_handover.md's v4 schema notes) — that is also the
// topic LessonView's own newWords/alreadyLearned logic will actually place it in, so it's the
// correct landing topic for a word search result. Falls back to the first-seen occurrence in
// the rare case a word_id has no "new" row.
export function buildWordEntries(curriculum) {
  const map = new Map();
  for (const topic of curriculum) {
    for (const word of topic.words) {
      const existing = map.get(word.word_id);
      if (!existing || (word.role_in_topic === "new" && existing.word.role_in_topic !== "new")) {
        map.set(word.word_id, { word, topic });
      }
    }
  }
  return [...map.values()];
}
